import { render } from "./IndexMenuItem.vue?vue&type=template&id=1fe7346e"
import script from "./IndexMenuItem.vue?vue&type=script&lang=js"
export * from "./IndexMenuItem.vue?vue&type=script&lang=js"

import exportComponent from "/home/forge/lf.m2geo.ie/releases/20261103161156/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Components/IndexMenuItem.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1fe7346e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1fe7346e', __exports__)) {
    console.log('reload')
    api.reload('1fe7346e', __exports__)
  }
  
  module.hot.accept("./IndexMenuItem.vue?vue&type=template&id=1fe7346e", () => {
    console.log('re-render')
    api.rerender('1fe7346e', render)
  })

}


export default __exports__